import { InternalThemeConfig } from "../../config";
import hexToRGBA from "../../../hexToRGBA";

const soft = (config: InternalThemeConfig) => {
    const { palette } = config;

    return {
        softPrimary: {
            backgroundColor: hexToRGBA(palette.black, 0.05),
            color: palette.primary,
            gap: "0.8rem",
            "&.activeButton, &:active": {
                backgroundColor: hexToRGBA(palette.primary, 0.36),
            },
            "&:hover": {
                backgroundColor: hexToRGBA(palette.primary, 0.12),
            },
            "&:disabled": {
                backgroundColor: "transparent !important",
                color: `${palette.grey30} !important`,
            },
        },
        softSecondary: {
            gap: "0.8rem",
            backgroundColor: hexToRGBA(palette.black, 0.3),
            color: palette.white,
            "&.activeButton, &:active": {
                backgroundColor: hexToRGBA(palette.primary, 0.36),
            },
            "&:hover": {
                backgroundColor: hexToRGBA(palette.primary, 0.12),
            },
            "&:disabled": {
                backgroundColor: "transparent !important",
                color: `${palette.grey30} !important`,
            },
        },
    };
};

export default soft;
